import React, { Component } from "react";
import db from "../../api/db";
import moment from "moment";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class Log extends Component {
  constructor(props) {
    super(props);

    this.state = {
      log: []
    };
  }

  static propTypes = {
    category: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  };

  componentDidMount() {
    this.searchQuery();
    this.setAutoReload();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  searchQuery() {
    db.query("log", {
      category: this.props.category,
      limit: 10
    }).then(response => {
      this.setState({
        log: response.data
      });
    });
  }

  setAutoReload() {
    this.interval = setInterval(() => this.searchQuery(), 60000);
  }

  render() {
    const date_format = "HH:mm DD.MM YYYY";

    return (
      <div className="sidebar">
        <h4>{this.props.title}</h4>
        <table>
          <thead>
            <tr>
              <th>Tid</th>
              <th>Melding</th>
            </tr>
          </thead>
          <tbody>
            {this.state.log.map((item, i) => (
              <React.Fragment key={item.id}>
                <tr className="spacer"></tr>
                <tr className={classNames(item.type, { odd: i % 2 })}>
                  <td>{moment.unix(item.date).format(date_format)}</td>
                  <td>{item.message}</td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        <Link to={"/log"} className="hollow button secondary mr">
          Hele loggen
        </Link>
        <Link to={"/jobs"} className="hollow button secondary">
          Index status
        </Link>
      </div>
    );
  }
}

export default Log;
